import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';

// DS
import {
  Col,
  VertContainer,
  VertSkeleton,
} from '@vertem-core/vertice-ds';

// SERVICES
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import PipeProvider from 'Services/Providers/PipeProvider';

// STYLES
import 'Assets/styles/default/components/Cart/CartItemListStyles.less';

// UTILS
import generateUUID from 'Utils/generateUUID';
import { addDimensionsCartGTM } from 'Shared/dataLayer/dataLayer';
import CartItemDesktop from './CartItemListDesktop';
import CartItemMobile from './CartItemListMobile';

const CartItemList = ({ setHasItemUnavailable, hasItemUnavailable }) => {
  /* Hooks */
  const { callApi } = usePipeContext();
  const itemsCartReducer = useSelector(({ Cart: data }) => data);
  /* States */
  const [aliasProvider, setAliasProvider] = useState('');
  const { cart } = itemsCartReducer;

  const cartItems = cart?.items || [];

  /* Utils */
  const groupedData = cartItems.reduce((result, item) => {
    const vendorId = item.vendor.id;
    if (!result[vendorId]) {
      result[vendorId] = [];
    }
    result[vendorId].push(item);

    return result;
  }, {});

  useEffect(() => {
    const aliasProviderUUID = generateUUID();
    setAliasProvider(aliasProviderUUID);
    callApi({
      symbol: 'FETCH_STORES',
      alias: aliasProviderUUID,
    });
  }, []);

  useEffect(() => {
    if (itemsCartReducer?.finishRequests && !itemsCartReducer?.hasError) {
      const aliasProviderUUID = generateUUID();
      callApi({
        symbol: 'FETCH_CART',
        alias: aliasProviderUUID,
      });
    }
  }, [itemsCartReducer?.finishRequests]);

  useEffect(() => {
    if (cartItems) {
      addDimensionsCartGTM(cartItems, 1);
    }
  }, [cartItems]);

  return (
    <PipeProvider
      apiSymbols={[
        { symbol: 'FETCH_CART', alias: aliasProvider },
        'FETCH_STORES',
      ]}
      loadingComponent={
        <VertContainer spacingX="small">
          <VertSkeleton paragraph={{ rows: 4 }} active />
        </VertContainer>
      }
    >
      <Col data-testid="cart-items" className="cart-item-list-wrapper">
        {/* Desktop version */}
        <MediaQuery minWidth={770}><CartItemDesktop setHasItemUnavailable={setHasItemUnavailable} hasItemUnavailable={hasItemUnavailable} groupedData={groupedData} /></MediaQuery>
        {/* Mobile version */}
        <MediaQuery maxWidth={769}> <CartItemMobile setHasItemUnavailable={setHasItemUnavailable} hasItemUnavailable={hasItemUnavailable} groupedData={groupedData}/> </MediaQuery>
      </Col>
    </PipeProvider>
  );
};

export default CartItemList;
